import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { AuthService } from '../auth/auth.service';
import { EntityService } from '../entity/entity.service';

export const opsGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const entityService = inject(EntityService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/auth/login']);
  }
  if (!authService.profileCompleted()) {
    return router.createUrlTree(['/auth/complete-profile']);
  }

  return entityService.getContexts().pipe(
    map((res) => {
      const isOps = res.contexts.some((c) => c.type === 'system' && c.ops_tier != null);
      return isOps ? true : router.createUrlTree(['/dashboard']);
    }),
    catchError(() => of(router.createUrlTree(['/dashboard']))),
  );
};
